// Hook modyfikacji wysyłki oferty – PUT /sales-crm/clients/:cid/offers/:oid/shipping

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPutSalesCrmOfferShippingPayload {
  warehouseId?: number | null;
  deliveryMethodId?: number | null;
  deliveryDate?: string | null;
  carrierName?: string | null;
  deliveryCost?: number | null;
  receiverId?: number | null;
  splitDeliveryCost?: boolean | null;
}

type IResponse = ICommandResponseSuccess;

const putSalesCrmOfferShipping = (
  clientId: number,
  offerId: string,
  payload: IPutSalesCrmOfferShippingPayload
): Promise<IResponse> =>
  axios.put(`/sales-crm/clients/${clientId}/offers/${offerId}/shipping`, payload);

export const usePutSalesCrmOfferShipping = (
  clientId: number,
  offerId: string,
  options?: UseMutationOptions<IResponse, IError, IPutSalesCrmOfferShippingPayload>
) =>
  useMutation(
    (payload: IPutSalesCrmOfferShippingPayload) =>
      putSalesCrmOfferShipping(clientId, offerId, payload),
    options
  );
